<template>
    <div class="baggage-selection-v2">
        <div class="baggage-section">
            <Info icon="NoBag" :title="t({ key: 'shared.no_baggage' })" />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import Info from './Shared/Info.vue';

    export default defineComponent({
        name: 'BaggageNone',
        components: { Info },
        methods: { t },
    });
</script>

<style lang="scss">
    @forward './BaggageSelectionForm.scss';
</style>
